'use strict';

/* globals config, $, socket */

require([
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
], function (Vue) {
	var internals = {};

	Vue.component('course-analytics-panel', {
		props: ['initData'],
		data: function () {
			return {
				groupedAttempts: this.initData.groupedAttempts,
				detailState: 'users', // users, attempts, attempt
				currentUserGroup: null,
				currentAttempt: null
			};
		},
		mounted: function () {

		},
		methods: {
			openGroups: function () {
				this.detailState = 'users';
			},
			openUserAttempts: function (userGroup) {
				this.detailState = 'attempts';
				
				if (userGroup)
					this.currentUserGroup = userGroup;
			},
			openAttempt: function (attempt) {
				this.detailState = 'attempt';
				this.currentAttempt = attempt;
			},
		},
		template:
		'<div>' +
			'<course-analytics-group-attempts v-if="detailState === \'users\'" :init-data="initData" :grouped-attempts="groupedAttempts" :open-user-attempts="openUserAttempts"></course-analytics-group-attempts>' +
			'<course-analytics-user-attempts v-if="detailState === \'attempts\'" :init-data="initData" :grouped-attempts="groupedAttempts" :user-group="currentUserGroup" :open-groups="openGroups" :open-attempt="openAttempt"></course-analytics-user-attempts>' +
			'<course-analytics-attempt v-if="detailState === \'attempt\'" :init-data="initData" :grouped-attempts="groupedAttempts" :attempt="currentAttempt" :open-user-attempts="openUserAttempts"></course-analytics-attempt>' +
		'</div>',
	});
});
